import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useTranslation from "../../hooks/traslation";
import { GRAPH_TYPE } from "../../utils/enums";
import { useEffect, useState } from "react";
import { useLazyGetFreelancerGraphQuery } from "../../services/dashboard";
import { showError } from "../../constants/toasts";

const MaintenanceTeamGraph = () => {
  const translation = useTranslation();
  const [freelancerData, setFreelancerData] = useState([]);
  const [isFreelancerLoading, setIsFreelancerLoading] = useState(false);
  const [freelancerGraphType, setFreelancerGraphType] = useState(
    GRAPH_TYPE.DAY
  );
  const [getFreelancerGraph] = useLazyGetFreelancerGraphQuery();

  //freelancer data
  const FreelancerGraph = async () => {
    setIsFreelancerLoading(true);
    try {
      const response = await getFreelancerGraph({
        type: freelancerGraphType,
      }).unwrap();
      if (response?.statusCode === 200) {
        setFreelancerData(response?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsFreelancerLoading(false);
    }
  };

  const handleFreelancerGraphTypeChange = (type: GRAPH_TYPE) => {
    setFreelancerGraphType(type);
    FreelancerGraph();
  };
  useEffect(() => {
    FreelancerGraph();
  }, [freelancerGraphType]);
  return (
    <>
      <div className="cards table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>{translation.main.totalFreelancer}</h2>
          </div>
          <div className="right_s">
            <p>
              <span
                className={`time-period ${
                  freelancerGraphType === GRAPH_TYPE.DAY ? "active" : ""
                }`}
                onClick={() => handleFreelancerGraphTypeChange(GRAPH_TYPE.DAY)}
              >
                {translation.main.aday}
              </span>
              <span
                className={`time-period ${
                  freelancerGraphType === GRAPH_TYPE.WEEK ? "active" : ""
                }`}
                onClick={() => handleFreelancerGraphTypeChange(GRAPH_TYPE.WEEK)}
              >
                {translation.main.aweek}
              </span>
              <span
                className={`time-period ${
                  freelancerGraphType === GRAPH_TYPE.MONTH ? "active" : ""
                }`}
                onClick={() =>
                  handleFreelancerGraphTypeChange(GRAPH_TYPE.MONTH)
                }
              >
                {translation.main.amonth}
              </span>
              <span
                className={`time-period ${
                  freelancerGraphType === GRAPH_TYPE.YEAR ? "active" : ""
                }`}
                onClick={() => handleFreelancerGraphTypeChange(GRAPH_TYPE.YEAR)}
              >
                {translation.main.ayear}
              </span>
            </p>
          </div>
        </div>
        <div className="graph-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={freelancerData}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 60,
              }}
              style={{ fontSize: 12 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={60}
                interval={0}
                tickFormatter={(value) => {
                  if (typeof value === "string") {
                    return (
                      value.charAt(0).toUpperCase() +
                      value.slice(1).toLowerCase()
                    );
                  }
                  return value;
                }}
              />
              <YAxis tick={{ fontSize: 10 }} width={80} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              />
              <Bar
                dataKey="value"
                fill="#BF2F17"
                radius={[4, 4, 0, 0]}
                barSize={40}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default MaintenanceTeamGraph;
